// import { Reducer } from 'react'
// import { AuthState, AuthTypes, AuthAction } from '../types/auth';

import { AuthState, AuthTypes } from '../types/auth'

const initialState: AuthState = {
  loading: false,
  error: '',
  isAuthenticated: false,
  access_token: '',
  searchUser: [],
  registrationData: {
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    password: '',
    confirmPassword: '',
    referred_by: '',
  },
  signForm: {},
}

export const authReducer = (state: AuthState = initialState, action: any) => {
  switch (action.type) {
    case AuthTypes.UPDATE_IS_AUTH:
      return {
        ...state,
        isAuthenticated: action.payload,
      }
    case AuthTypes._UPDATE_SIGN_UP_FORM: {
      return {
        ...state,
        signForm: {
          ...state.signForm,
          ...action.payload,
        },
      }
    }
    case AuthTypes.SEARCH_INVITEE_SUCCESS: {
      return {
        ...state,
        searchUser: action.payload,
      }
    }

    case AuthTypes._CLEAR_SIGN_UP_FORM: {
      return {
        ...state,
        signForm: initialState.signForm,
      }
    }
    case AuthTypes.UPDATE_ACCESS_TOKEN:
      return {
        ...state,
        access_token: action.payload,
      }

    case AuthTypes.REGISTRATION_DATA:
      return {
        ...state,
        registrationData: {
          ...state.registrationData,
          ...action.payload,
        },
      }

    case AuthTypes.LOGIN_REQUEST_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    case AuthTypes.VERIFY_NUMBER_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    case AuthTypes.VERIFY_NUMBER_SUCCESS:
      return {
        ...state,
      }
    case AuthTypes.VERIFY_EMAIL_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    case AuthTypes.VERIFY_EMAIL_SUCCESS:
      return {
        ...state,
      }

    default:
      return state
  }
}

// const initialState: AuthState = {
//   access_token: '',
//   isAuthenticated: false,
//   loading: false,
//   email: '',
//   error: '',
//   phone_number: '',
// }

// const authReducer: Reducer<AuthState, AuthAction> = (
//   state = initialState,
//   action: AuthAction
// ): AuthState => {
//   switch (action.type) {
//     case AuthTypes.LOGIN_REQUEST:
//       return {
//         ...state,
//         email: '',
//         loading: true,
//         error: '',
//       }
//     case AuthTypes.LOGIN_REQUEST_SUCCESS:
//       return {
//         ...state,
//         email: action.payload.email,
//         loading: false,
//         error: '',
//       }
//     case AuthTypes.LOGIN_REQUEST_ERROR:
//       return {
//         ...state,
//         error: action.payload.error,
//       }
//     case AuthTypes.SIGNUP_REQUEST:
//       return {
//         ...state,
//         email: '',
//         loading: true,
//         error: '',
//       }
//     case AuthTypes.SIGNUP_REQUEST_SUCCESS:
//       return {
//         ...state,
//         access_token: action.payload.access_token,
//         isAuthenticated: action.payload.isAuthenticated,
//         email: action.payload.email,
//         loading: false,
//         error: '',
//       }
//     case AuthTypes.SIGNUP_REQUEST_ERROR:
//       return {
//         ...state,
//         error: action.payload.error,
//       }

//     case AuthTypes.VERIFY_EMAIL_REQUEST:
//       return {
//         ...state,
//         email: '',
//         loading: true,
//         error: '',
//       }

//     case AuthTypes.VERIFY_EMAIL_SUCCESS:
//       return {
//         ...state,
//         email: action.payload.email,
//         loading: false,
//         error: '',
//       }

//     case AuthTypes.VERIFY_EMAIL_ERROR:
//       return {
//         ...state,
//         error: action.payload.error,
//       }

//     case AuthTypes.VERIFY_NUMBER_REQUEST:
//       return {
//         ...state,
//         phone_number: '',
//         loading: true,
//         error: '',
//       }

//     case AuthTypes.VERIFY_NUMBER_SUCCESS:
//       return {
//         ...state,
//         phone_number: action.payload.phone_number,
//         loading: false,
//         error: '',
//       }

//     case AuthTypes.VERIFY_NUMBER_ERROR:
//       return {
//         ...state,
//         error: action.payload.error,
//       }

//     default:
//       return state
//   }
// }

// export { authReducer }
